let GmapVisitBlock, gmapSettings;

const gmapJSON = document.getElementById("gmap-json-data");
if (gmapJSON) {
    gmapSettings = JSON.parse(gmapJSON.textContent);
}

function getStaticMap() {
    // Base URL for Google Maps Static API
    const baseUrl = "https://maps.googleapis.com/maps/api/staticmap";
    const Latitude = gmapSettings.lat;
    const Longitude = gmapSettings.lng;

    const url = new URL(window.location.href);
    const iconURL = `${url.origin}/wp-content/themes/park-theatre-theme/public/images/map-marker.png`;

    const params = {
        center: `${Latitude},${Longitude}`,
        zoom: 17, // Zoom level (closer = higher number)
        size: "800x683",
        markers: `icon:${iconURL}|${Latitude},${Longitude}`, // Add a marker at the center
        key: `${gmapSettings.key}`,
    };

    const queryString = Object.keys(params)
        .map((key) => key + "=" + encodeURIComponent(params[key]))
        .join("&");

    let mapUrl = `${baseUrl}?${queryString}`;

    document.getElementById("static-map-img").src = mapUrl;

    return mapUrl;
}

// Call the function to generate the static map
if (gmapJSON && gmapSettings.key && gmapSettings.place_id) {
    GmapVisitBlock = getStaticMap();
}

export default GmapVisitBlock;
